import { ApiMethodForm } from "components/Forms/ConnectionCreatorEditorFormSections/ApiMethodForm";
import { StepForm } from "components/Forms/ConnectionCreatorEditorFormSections/StepForm";
import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { FC } from "react";

import IncomingPostbackDataOptional = App.Data.IncomingPostbackDataOptional;
import HandleIncomingPostbackRequest = App.Http.Requests.Tracking.HandleIncomingPostbackRequest;

interface ApiMethodPanelProps {
    postback?: IncomingPostbackDataOptional;
    name: number;
    handleRemoveMethod: () => void;
    disabled: boolean;
}

export const ApiMethodPanel: FC<ApiMethodPanelProps> = ({ name, handleRemoveMethod, disabled }) => {
    const leadFields: Array<keyof HandleIncomingPostbackRequest | "id"> =
        [
            "id",
            "eid",
            "advertiser_id",
            "advertiser_custom_id",
            "owner_id",
            "owner_custom_id",
            "type",
            "value",
            "commission_id",
            "commission",
            "currency",
            "offer_id",
            "conversion_date",
            "conversion_id",
            "customer_id",
        ] || [];

    return (
        <Collapseable
            header={<StepForm name={name} handleRemoveMethod={handleRemoveMethod} disabled={disabled} />}
            collapsible={disabled ? "disabled" : "icon"}
            className={disabled ? "bg-neutral-100 opacity-45 p-1" : "bg-neutral-100 p-1"}
        >
            <ApiMethodForm leadFields={leadFields} name={name} />
        </Collapseable>
    );
};
